import { LocationStrategy } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { SpinnerService } from '../../_components/spinner/spinner.service';
import { Restaurant, Companion, Slot } from '../../_models';
import {
  AuthService,
  CostaAppService,
  DateService,
  HomeService,
} from '../../_services';
import { SessionStoragerService, Constants } from '../../_utility';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class SummaryComponent {
  public restaurant: Restaurant | null | undefined;
  public passengers: Array<Companion> = [];
  public slot!: any;
  public autologin: boolean = true;

  constructor(
    private router: Router,
    public auth: AuthService,
    private service: HomeService,
    private spinner: SpinnerService,
    private sStore: SessionStoragerService,
    private location: LocationStrategy,
    private message: MessageService,
    private costaApp: CostaAppService,
    public translate: TranslateService,
    public dateService: DateService
  ) {
    this.autologin = this.sStore.getElement(Constants.Storager.AUTOLOGIN);
    let restaurant = this.sStore.getElement(Constants.Storager.RESTAURANT);
    let passengers = this.sStore.getElement(Constants.Storager.COMPANIONS);
    let slot = this.sStore.getElement(Constants.Storager.SLOT);

    if (restaurant && passengers && slot) {
      this.restaurant = restaurant;
      this.passengers = passengers;
      this.slot = slot;
    } else {
      this.router.navigate(Constants.Routing.HOME.routerLink);
    }
  }

  Back() {
    this.location.back();
  }

  Submit() {
    let arr = [];
    for (let o of this.passengers) {
      arr.push(o.uuid_passenger);
    }
    let data = {
      uuid_restaurant: this.restaurant!.uuid_restaurant,
      uuid_passengers: arr,
      uuid_restaurant_slot: this.slot!.slot.uuid_restaurant_slot,
    };
    this.spinner.show();
    this.service.SetReservation(data).subscribe({
      next: (res) => {
        this.costaApp.confirm();
        let phone_number = this.sStore.getElement(
          Constants.Storager.PHONE_NUMBER
        );
        this.sStore.clearAll();
        this.sStore.setElement(Constants.Storager.RESERVATION, res);
        this.sStore.setElement(Constants.Storager.AUTOLOGIN, this.autologin);
        this.sStore.setElement(Constants.Storager.PHONE_NUMBER, phone_number);
        this.spinner.hide();
        this.router.navigate(Constants.Routing.COMPLETE_RESERVATION.routerLink);
      },
    });
  }
}

// const RESERVATION: any = {
//   date: '2025-03-15',
//   date_time: '19.00',
//   booked_by: 'Simone Rossi',
//   companion: ['Simone Rossi', 'Giada Rossi'],
//   restaurant: 'Pizzeria Pummo',
//   img_url: 'url',
//   message:
//     'Per cancellare o modificare la prenotazione recarsi sl ristorante Pizzeria Pummid’oro situazione al deck 8.',
// };
